import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUtilityModule } from '../common-utility/common-utility.module';
import { DrawerBackgroundToolComponent } from './components/drawer-background-tool/drawer-background-tool.component';
import { DrawerColorPickerComponent } from './components/drawer-color-picker/drawer-color-picker.component';
import { DrawerEraserToolComponent } from './components/drawer-eraser-tool/drawer-eraser-tool.component';
import { DrawerFiguresToolComponent } from './components/drawer-figures-tool/drawer-figures-tool.component';
import { DrawerSettingsComponent } from './components/drawer-settings/drawer-settings.component';
import { DrawerTextComponent } from './components/drawer-text/drawer-text.component';
import { DrawerTextsComponent } from './components/drawer-texts/drawer-texts.component';
import { TextbookDrawerModule } from '@textbook-drawer';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReactiveFormsModule } from '@angular/forms';
import { DrawerTextMobileComponent } from './components/drawer-text-mobile/drawer-text-mobile.component';
import { AbstractDrawerTextComponent } from './components/drawer-text/abstract-drawer-text.component';

const components = [
  DrawerBackgroundToolComponent,
  DrawerColorPickerComponent,
  DrawerEraserToolComponent,
  DrawerFiguresToolComponent,
  DrawerTextComponent,
  DrawerSettingsComponent,
  DrawerTextsComponent,
  DrawerTextMobileComponent,
];

@NgModule({
  declarations: [AbstractDrawerTextComponent, components],
  exports: [components],
  imports: [
    CommonModule,
    CommonUtilityModule,
    TextbookDrawerModule,
    DragDropModule,
    ReactiveFormsModule,
  ],
})
export class DrawingUtilityModule {}
